import WallFactory from './wall-factory';
import AreaFactory from './area-factory';
import PipeFactoryGas from './pipe-factory-gas';
import PipeFactoryWater from './pipe-factory-water';
export { WallFactory, AreaFactory, PipeFactoryGas, PipeFactoryWater };

export default {
  WallFactory: WallFactory,
  AreaFactory: AreaFactory,
  PipeFactoryGas: PipeFactoryGas,
  PipeFactoryWater: PipeFactoryWater
};